<script >import Layout from './Layout.svelte';
import { classNames } from './utils';
let _class = '';
export { _class as class };
export let style = {};
export let justifyContent = undefined;
export let alignContent = undefined;
export let alignItems = undefined;
export let justifySelf = undefined;
export let alignSelf = undefined;
export let gap = undefined;
export let wrap = undefined;
export let basis = undefined;
export let grow = undefined;
export let order = undefined;
export let shrink = undefined;
export let flex = undefined;
export let area = undefined;
export let col = undefined;
export let colEnd = undefined;
export let colStart = undefined;
export let row = undefined;
export let rowEnd = undefined;
export let rowStart = undefined;
export let padding = style['padding'];
export let margin = style['margin'];
export let width = style['width'];
export let height = style['height'];
export let boxSizing = style['boxSizing'] ?? 'border-box';
export let inline = false;
export let reverse = false;
export let use = () => { };
</script>

<Layout
	class={classNames(_class, 'row')}
	{inline}
	{reverse}
	width={width === true}
	height={height === true}
	{use}
	style={{
		...style,
		alignContent,
		alignItems,
		justifyContent,
		justifySelf,
		alignSelf,
		gap,
		wrap,
		basis,
		grow,
		shrink,
		flex,
		order,
		colStart,
		colEnd,
		rowStart,
		rowEnd,
		col,
		row,
		area,
		padding,
		margin,
		width,
		height,
		boxSizing
	}}
>
	<slot />
</Layout>
